module.exports = __webpack_public_path__ + "img/68.c7f4414c.jpg";